import React from 'react';
import { colors } from '../utils/colors';

function ColorPalette() {
  const colorGroups = [
    {
      title: 'Primary Colors',
      colors: [
        { name: 'Aquamarine', value: colors.aquamarine, class: 'aquamarine' },
        { name: 'Cerulean', value: colors.cerulean, class: 'cerulean' },
        { name: 'Space Cadet', value: colors.spaceCadet, class: 'space-cadet' },
        { name: 'Mint Green', value: colors.mintGreen, class: 'mint-green' },
        { name: 'Coral', value: colors.coral, class: 'coral' },
        { name: 'Timberwolf', value: colors.timberwolf, class: 'timberwolf' },
      ]
    },
    {
      title: 'Primary Scale',
      colors: Object.entries(colors.primary).map(([shade, value]) => ({
        name: `Primary ${shade}`,
        value,
        class: `primary-${shade}`
      }))
    },
    {
      title: 'Secondary Scale',
      colors: Object.entries(colors.secondary).map(([shade, value]) => ({
        name: `Secondary ${shade}`,
        value,
        class: `secondary-${shade}`
      }))
    }
  ];

  return (
    <div className="max-w-6xl mx-auto p-8">
      <div className="mb-12">
        <h1 className="text-4xl font-bold text-space-cadet mb-4">Family Bible App Color Palette</h1>
        <p className="text-lg text-gray-600">
          A carefully curated color palette for the Family Bible App. Use these colors throughout the application for consistent branding.
        </p>
      </div>

      {colorGroups.map((group, groupIndex) => (
        <div key={groupIndex} className="mb-12">
          <h2 className="text-2xl font-semibold text-space-cadet mb-6">{group.title}</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {group.colors.map((color, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                <div 
                  className="h-24 w-full"
                  style={{ backgroundColor: color.value }}
                ></div>
                <div className="p-4">
                  <div className="text-sm font-medium text-space-cadet mb-1">
                    {color.name}
                  </div>
                  <div className="text-xs text-gray-500 font-mono mb-2">
                    {color.value}
                  </div>
                  <div className="text-xs text-cerulean font-mono">
                    .{color.class}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="bg-mint-green rounded-lg p-6">
        <h3 className="text-xl font-semibold text-space-cadet mb-4">Usage Examples</h3>
        <div className="space-y-4">
          <div>
            <h4 className="font-medium text-space-cadet mb-2">Tailwind Classes:</h4>
            <div className="bg-white rounded p-3 font-mono text-sm">
              <div className="text-cerulean">bg-primary-500</div>
              <div className="text-aquamarine">text-aquamarine</div>
              <div className="text-space-cadet">border-space-cadet</div>
              <div className="text-mint-green">bg-mint-green</div>
            </div>
          </div>
          
          <div>
            <h4 className="font-medium text-space-cadet mb-2">CSS Variables:</h4>
            <div className="bg-white rounded p-3 font-mono text-sm">
              <div>var(--color-cerulean)</div>
              <div>var(--color-aquamarine)</div>
              <div>var(--color-space-cadet)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ColorPalette;
